import VideoPlayerComponent from './VideoPlayerComponent';

export default VideoPlayerComponent;
